import React, { useState } from 'react';
import { DatePicker, Form } from '@bancobarigui/barihaus';
import dayjs from 'dayjs';

import { ReportButtonWrapper, ReportButton, ReportNMPFormItem } from './styles';
import DontDisturbService from '../../services/DontDisturbService';

const { RangePicker } = DatePicker;

const today = dayjs();

type AlertStatus = 'success' | 'error' | null;

interface ReportNMPProps {
  onAlertChange: (status: AlertStatus) => void;
}

const ReportNMP: React.FC<ReportNMPProps> = ({ onAlertChange }) => {
  const [loading, setLoading] = useState(false);

  const handleGenerateReport = async () => {
    setLoading(true);
    onAlertChange(null);
    try {
      const files = await DontDisturbService.fetchFiles();
      files.forEach((file) => {
        const link = document.createElement('a');
        link.href = file.url;
        link.download = file.fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
      onAlertChange('success');
    } catch {
      onAlertChange('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ReportNMPFormItem>
        <Form.Item label="Período" name="period">
          <RangePicker disabled format="DD/MM/YYYY" defaultValue={[today, today]} />
        </Form.Item>
      </ReportNMPFormItem>
      <ReportButtonWrapper>
        <ReportButton buttonColor="secondary" loading={loading} onClick={handleGenerateReport}>
          Gerar Relatório
        </ReportButton>
      </ReportButtonWrapper>
    </>
  );
};

export default ReportNMP;
